export const UPGRADE_NOTICE = {
    enabled: false,
    title: 'System Upgrade In Progress',
    message: 'We are upgrading our system. If you find any issue, please contact support.',
    email: 'info@grouptravelvideos.com',
    phone: '888-533-7637 x204',
};
